// extracted by mini-css-extract-plugin
export default {"close":"close_close__G5lF6","cross":"close_cross__upFNN","inline":"close_inline__1vYKV"};